export default "__VITE_ASSET__CZ1XS3K6__"